<template>
  <!--质量经理上传自检资料-->
  <h-form-page :title="h_i18n('83611abd5f806cb2db7cb992e91186dd')" @inspection-update="inspectionUpdate">
    <div class="page">
      <div class="table-top">
        <div class="title-table">
          <div class="left">{{ h_i18n('9e5ffa068ed435ced73dc9bf5dd8e09c') }}</div>
          <div>{{ h_i18n('0dfedd58f37571cc86caec5f09366bdb') }}{{ mainData.patternPlanId }}</div>
        </div>
        <div class="item">
          <table cellspacing="0" cellpadding="0" border="0" class="item_table">
            <colgroup>
              <col width="8%"/>
              <col/>
              <col width="10%"/>
              <col width="160"/>
              <col width="170"/>
              <col width="170"/>
              <col width="100"/>
              <col width="100"/>
              <col width="180"/>
            </colgroup>
            <thead>
            <tr>
              <th>{{ h_i18n('ba1ec95765e96f14718f6e9a7578a2be') }}</th>
              <th>{{ h_i18n('aca38f22397ec3789f862612019ff66c') }}</th>
              <th>{{ h_i18n('fac54c3430528339ac075d688db27ce8') }}</th>
              <th>{{ h_i18n('966e7cdd840bbbfbea1299df9007fde5') }}</th>
              <th>{{ h_i18n('f1edca9f040d256cee01ef89fa5499f0') }}</th>
              <th>{{ h_i18n('8be579a49ad89adf491bcd7c42eca35c') }}</th>
              <th>{{ h_i18n('03490f3868798323211aa633194df2c1') }}</th>
              <!-- <th>型号经理</th> -->
              <th>{{ h_i18n('37449bad8f75c8a898df87140c13b186') }}</th>
              <th>{{ h_i18n('86c931cb137ce967bcdc23569a60f09c') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{ beforeData.supplyCode }}</td>
              <td>{{ beforeData.supplyName }}</td>
              <td>{{ beforeData.mtlName }}</td>
              <td>all</td>
              <td>{{ beforeData.mtlNo }}</td>
              <td>{{ beforeData.materielCategoryName }}</td>
              <td>{{ beforeData.sybName }}</td>
              <!-- <td>{{ beforeData.modelManagerId }}</td> -->
              <td>
                <div class="h-global-font--blue item-look" @click="lookM(beforeData.mtlNo,beforeData.supplyCode)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</div>
              </td>
              <td>
                <div class="h-global-font--blue item-look" @click="lookT()">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="table-tab">
        <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
          <el-tab-pane :label="h_i18n('e3452eba8e848e0019818a56062c7346')" name="1">
            <div class="tab-item">
              <div class="table-item-button">
                <h-button-group>
                  <h-button type="primary" solid disabled v-if="tableList.phase1.commitStatus==='R'">
                    <template #icon>
                      <back-one/>
                    </template>{{ h_i18n('72649d75afec4f4ddbc7987cf765bcec') }}</h-button>
                  <h-button type="primary" solid disabled v-if="tableList.phase1.commitStatus==='Y'">
                    <template #icon>
                      <check/>
                    </template>{{ h_i18n('ecfa64c174d344d58f31a839c26bd7f9') }}</h-button>
                  <h-button type="primary" solid disabled v-if="tableList.phase1.submitStatus==='N'">{{ h_i18n('134ca59583858032ddafd01199eb3dd1') }}</h-button>
                  <template v-else>
                    <h-button type="primary" solid @click="publish(1,'no-pass')" v-if="tableList.phase1.commitStatus==='N'">
                      <template #icon>
                        <back-one/>
                      </template>{{ h_i18n('9a7b15dccc5cda2e3db1110678576104') }}</h-button>
                    <h-button type="primary" solid @click="publish(1,'pass')" v-if="tableList.phase1.commitStatus==='N'">
                      <template #icon>
                        <check/>
                      </template>{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</h-button>
                  </template>
                </h-button-group>
                <div class="text">{{ h_i18n('f7a8825ce6af26bf22ad6ff332d52406') }}</div>
              </div>
              <div class="table-item-table">
                <h-table-card :title="h_i18n('19fde6e4eac33cf5a9befed79c2309c8')">
                  <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" border :data="tableList.phase1.list" size="small"
                            @row-click.self="rowClick" :highlight-current-row="true" v-loading="tableListLoading"
                            :class="tableList.phase1['submitStatus']==='N'?'row-change':''">
                    <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')"></el-table-column>
                    <el-table-column label="*" width="60">
                      <template #header>
                        <div class="dangerColor center">*</div>
                      </template>
                      <template #default="{row}">
                        <div class="dangerColor center" v-if="row.isNeed==='Y'">*</div>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')" min-width="200">
                      <template #default="{row}">
                        <div class="text_item">{{ row.documentName }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('5b7fe94eb8c9dd382866a54435a9680e')" width="80">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.isSubmit === "Y" ? h_i18n('0a60ac8f02ccd2cf723f927284877851') : row.isSubmit === "N" ? h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') : "" }}</div>
                        <el-select v-else v-model="row.isSubmit">
                          <el-option value="Y" :label="h_i18n('0a60ac8f02ccd2cf723f927284877851')"></el-option>
                          <el-option value="N" :label="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('9628c97d0a76ac2f7ddc699f7c838054')" width="80">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.selfPromise === "Y" ? h_i18n('0a60ac8f02ccd2cf723f927284877851') : row.selfPromise === "N" ? h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') : "" }}</div>
                        <el-select v-else v-model="row.selfPromise">
                          <el-option value="Y" :label="h_i18n('0a60ac8f02ccd2cf723f927284877851')"></el-option>
                          <el-option value="N" :label="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')" min-width="200">
                      <template #default="{row}">
                        <h-file-upload delete download v-model="row.file" :only-show="tableList.phase1['submitStatus']==='Y'" @error="error" @download="download" @change="fileUploadToServer"></h-file-upload>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('e080329c020dc42739b9c0a043845712')" width="100">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.submitMan }}</div>
                        <el-input v-else v-model="row.submitMan"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('fb4cc0f776e82afd9c2b6ca157ddc639')" width="170">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ time(row.submitTime) }}</div>
                        <el-date-picker v-else v-model="row.submitTime" @change="changeTime(row.submitTime,row,'submitTime')" type="date"></el-date-picker>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('f2f6965f535dc9b2e0c14ad1fe521d5c')" width="100" v-if="tableList.phase1['checkStatus']==='R'">
                      <template #default="{row}">
                        {{ row.checkConclusion === "P" ? h_i18n('23c1f39900b3af4c3263449782e288e1') : row.checkConclusion === "F" ? h_i18n('9a7b15dccc5cda2e3db1110678576104') : h_i18n('2839c8c87d814d9a1e592965fae86b54') }}
                      </template>
                    </el-table-column>
                    <!-- <el-table-column label="海尔校核人" width="90" v-if="tableList.phase1['checkStatus']==='R'">
                      <template #default="{row}">
                        {{ row.checkManId }}
                      </template>
                    </el-table-column> -->
                    <el-table-column :label="h_i18n('6dfa721bf8e1c030997a72faeb4f5310')" width="100" v-if="tableList.phase1['checkStatus']==='R'">
                      <template #default="{row}">
                        {{ row.checkDepartment }}
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('8fce8f8923ab0343df4f1a0eb374a839')" width="100" v-if="tableList.phase1['checkStatus']==='R'">
                      <template #default="{row}">
                        {{ time(row.checkTime, 6) }}
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('6a64cef2c9cb2c04294df46180ac44b5')" width="100">
                      <template #default="{row}">
                        <div class="h-global-font--blue" @click="lookHistory(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</div>
                      </template>
                    </el-table-column>
                  </el-table>
                </h-table-card>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="h_i18n('8ac399bf0a389c62337625923649b685')" name="2">
            <div class="tab-item" v-if="!tableList.phase2.plan">
              <div class="table-item-button">
                <h-button type="default" @click="tableList.phase2.plan=true">
                  <template #icon>
                    <left/>
                  </template>{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
                <div class="text">{{ h_i18n('e24db6254b0f2d9a44f1fb23e0af1cd3') }}</div>
              </div>
              <div class="table-item-table">
                <h-table-card :title="h_i18n('19fde6e4eac33cf5a9befed79c2309c8')" :h-data="tableList.phase2.materials">
                  <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" border :data="tableList.phase2.materials" size="small"
                            @row-click.self="rowClick" :highlight-current-row="true" v-loading="tableListLoading"
                            @selection-change="listCheckBoxChange" :class="tableList.phase2['submitStatus']==='N'?'row-change':''">
                    <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')"></el-table-column>
                    <el-table-column :label="h_i18n('911b9a994284ec787f4f24d6f25f3fe2')" width="200">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.series === "1" ? h_i18n('a86b76d1ac7e23fbe6811914dddedd66') : row.series === "2" ? h_i18n('50657dd5fba0f4c56301994b9435ed73') : row.series === "3" ? h_i18n('6d29d5c1c563430c254a0571e5498a5f') : "" }}</div>
                        <el-select v-else v-model="row.series">
                          <el-option value="1" :label="h_i18n('a86b76d1ac7e23fbe6811914dddedd66')"></el-option>
                          <el-option value="2" :label="h_i18n('50657dd5fba0f4c56301994b9435ed73')"></el-option>
                          <el-option value="3" :label="h_i18n('6d29d5c1c563430c254a0571e5498a5f')"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('82428b489879f605914215b9876caa40')" min-width="200">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.partNumber }}</div>
                        <el-input v-else v-model="row.partNumber"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('2bb79b0b11fb5f902349598676e2060e')" min-width="200">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.partName }}</div>
                        <el-input v-else v-model="row.partName"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('9ee1d06b4fb650c3e5fcc49929675caf')" min-width="200">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.materialName }}</div>
                        <el-input v-else v-model="row.materialName"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('40c9875bd7978fac4de81ef58a454d28')" min-width="200">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.specification }}</div>
                        <el-input v-else v-model="row.specification"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('ed765ced3449b75aa70a4f5c10ad1334')" prop="Zip" width="230">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.partStatusList.join(",") }}</div>
                        <el-checkbox-group class="center" v-model="row.partStatusList" v-else @change="specificationChange(row)" size="small">
                          <el-checkbox :label="h_i18n('f5f45a306153e09e6b55aa8989e62e29')"/>
                          <el-checkbox :label="h_i18n('762f7d6568ff7dcbccb00c818e08c451')"/>
                        </el-checkbox-group>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('4dfbb9aa4ac63454b70dfd8bbe09def7')" prop="Zip" width="160">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.productSupplier }}</div>
                        <el-input v-else v-model="row.productSupplier"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </h-table-card>
              </div>
            </div>
            <div class="tab-item" v-else>
              <div class="table-item-button">
                <h-button-group>
                  <h-button type="primary" solid disabled v-if="tableList.phase2.commitStatus==='R'">
                    <template #icon>
                      <back-one/>
                    </template>{{ h_i18n('72649d75afec4f4ddbc7987cf765bcec') }}</h-button>
                  <h-button type="primary" solid disabled v-if="tableList.phase2.commitStatus==='Y'">
                    <template #icon>
                      <check/>
                    </template>{{ h_i18n('ecfa64c174d344d58f31a839c26bd7f9') }}</h-button>
                  <h-button type="primary" solid disabled v-if="tableList.phase2.submitStatus==='N'">{{ h_i18n('62b7467cd12515fe99f13c1de3467b49') }}</h-button>
                  <h-button type="primary" solid disabled v-else-if="tableList.phase1.commitStatus==='N'">{{ h_i18n('c0eee4469985714eb439737ef65f3914') }}</h-button>
                  <template v-else>
                    <h-button type="primary" solid @click="publish(2,'no-pass')" v-if="tableList.phase2.commitStatus==='N'">
                      <template #icon>
                        <back-one/>
                      </template>{{ h_i18n('9a7b15dccc5cda2e3db1110678576104') }}</h-button>
                    <h-button type="primary" solid @click="publish(2,'pass')" v-if="tableList.phase2.commitStatus==='N'">
                      <template #icon>
                        <check/>
                      </template>{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</h-button>
                  </template>
                </h-button-group>
                <div class="text">{{ h_i18n('23722becf2ec2be4038c05158d2675c3') }}</div>
              </div>
              <div class="table-item-table">
                <h-table-card :title="h_i18n('19fde6e4eac33cf5a9befed79c2309c8')">
                  <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" border :data="tableList.phase2.list" size="small"
                            @row-click="rowClick" :highlight-current-row="true" v-loading="tableListLoading"
                            ref="inspectionTesting" :class="tableList.phase2['submitStatus']==='N'?'row-change':''">
                    <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')"></el-table-column>
                    <el-table-column label="*" width="60">
                      <template #header>
                        <div class="dangerColor center">*</div>
                      </template>
                      <template #default="{row}">
                        <div class="dangerColor center" v-if="row.isNeed==='Y'">*</div>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')" min-width="200">
                      <template #default="{row}">
                        <div class="text_item">{{ row.documentName }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('5b7fe94eb8c9dd382866a54435a9680e')" width="80">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.isSubmit === "Y" ? h_i18n('0a60ac8f02ccd2cf723f927284877851') : row.isSubmit === "N" ? h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') : "" }}</div>
                        <el-select v-else v-model="row.isSubmit">
                          <el-option value="Y" :label="h_i18n('0a60ac8f02ccd2cf723f927284877851')"></el-option>
                          <el-option value="N" :label="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('9628c97d0a76ac2f7ddc699f7c838054')" width="80">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.selfPromise === "Y" ? h_i18n('0a60ac8f02ccd2cf723f927284877851') : row.selfPromise === "N" ? h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') : "" }}</div>
                        <el-select v-else v-model="row.selfPromise">
                          <el-option value="Y" :label="h_i18n('0a60ac8f02ccd2cf723f927284877851')"></el-option>
                          <el-option value="N" :label="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')" min-width="200">
                      <template #default="{row}">
                        <div v-if="row.documentName.includes('二三级物料清单')">
                          <span class="h-global-font--blue" @click="tableList.phase2.plan=false">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</span>
                        </div>
                        <div v-else>
                          <div v-if="!row.checkFront" class="text_item">{{ row.partName }}</div>
                          <h-file-upload delete download v-model="row.file" :only-show="tableList.phase2['submitStatus']==='Y'" @error="error" @download="download" @change="fileUploadToServer"></h-file-upload>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('e080329c020dc42739b9c0a043845712')" width="100">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.submitMan }}</div>
                        <el-input v-else v-model="row.submitMan"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('fb4cc0f776e82afd9c2b6ca157ddc639')" width="170">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ time(row.submitTime) }}</div>
                        <el-date-picker v-else v-model="row.submitTime" @change="changeTime(row.submitTime,row,'submitTime')" type="date"></el-date-picker>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('f2f6965f535dc9b2e0c14ad1fe521d5c')" width="100" v-if="tableList.phase2['checkStatus']==='R'">
                      <template #default="{row}">
                        {{ row.checkConclusion === "P" ? h_i18n('23c1f39900b3af4c3263449782e288e1') : row.checkConclusion === "F" ? h_i18n('9a7b15dccc5cda2e3db1110678576104') : h_i18n('2839c8c87d814d9a1e592965fae86b54') }}
                      </template>
                    </el-table-column>
                    <!-- <el-table-column label="海尔校核人" width="90" v-if="tableList.phase2['checkStatus']==='R'">
                      <template #default="{row}">
                        {{ row.checkManId }}
                      </template>
                    </el-table-column> -->
                    <el-table-column :label="h_i18n('6dfa721bf8e1c030997a72faeb4f5310')" width="100" v-if="tableList.phase2['checkStatus']==='R'">
                      <template #default="{row}">
                        {{ row.checkDepartment }}
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('8fce8f8923ab0343df4f1a0eb374a839')" width="100" v-if="tableList.phase2['checkStatus']==='R'">
                      <template #default="{row}">
                        {{ time(row.checkTime, 6) }}
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('6a64cef2c9cb2c04294df46180ac44b5')" width="100">
                      <template #default="{row}">
                        <div class="h-global-font--blue" @click="lookHistory(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</div>
                      </template>
                    </el-table-column>
                  </el-table>
                </h-table-card>
              </div>
            </div>

          </el-tab-pane>
          <el-tab-pane :label="h_i18n('cc457a70b129995efbebe2217b0f441d')" name="3">
            <div class="tab-item">
              <div class="table-item-button">
                <h-button-group>
                  <h-button type="primary" solid disabled v-if="tableList.phase3.commitStatus==='R'">
                    <template #icon>
                      <back-one/>
                    </template>{{ h_i18n('72649d75afec4f4ddbc7987cf765bcec') }}</h-button>
                  <h-button type="primary" solid disabled v-if="tableList.phase3.commitStatus==='Y'">
                    <template #icon>
                      <check/>
                    </template>{{ h_i18n('ecfa64c174d344d58f31a839c26bd7f9') }}</h-button>
                  <h-button type="primary" solid disabled v-if="tableList.phase3.submitStatus==='N'">{{ h_i18n('d44e607f716209d68d46f0893573765d') }}</h-button>
                  <h-button type="primary" solid disabled v-else-if="tableList.phase2.commitStatus==='N'">{{ h_i18n('37d0b6e16a5d4a1f7d49e33d4a4e6aca') }}</h-button>
                  <template v-else>
                    <h-button type="primary" solid @click="publish(3,'no-pass')" v-if="tableList.phase3.commitStatus==='N'">
                      <template #icon>
                        <back-one/>
                      </template>{{ h_i18n('9a7b15dccc5cda2e3db1110678576104') }}</h-button>
                    <h-button type="primary" solid @click="publish(3,'pass')" v-if="tableList.phase3.commitStatus==='N'">
                      <template #icon>
                        <check/>
                      </template>{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</h-button>
                  </template>
                </h-button-group>
                <div class="text">{{ h_i18n('a3014170b8e17131ab796f2c555232c2') }}</div>
              </div>
              <div class="table-item-table">
                <h-table-card :title="h_i18n('19fde6e4eac33cf5a9befed79c2309c8')">
                  <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" border :data="tableList.phase3.list" size="small"
                            @row-click="rowClick" :highlight-current-row="true" v-loading="tableListLoading"
                            ref="technicalStandard" :class="tableList.phase3['submitStatus']==='N'?'row-change':''">
                    <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')"></el-table-column>
                    <el-table-column label="*" width="60">
                      <template #header>
                        <div class="dangerColor center">*</div>
                      </template>
                      <template #default="{row}">
                        <div class="dangerColor center" v-if="row.isNeed==='Y'">*</div>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')" min-width="200">
                      <template #default="{row}">
                        <div class="text_item">{{ row.documentName }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('5b7fe94eb8c9dd382866a54435a9680e')" width="80">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.isSubmit === "Y" ? h_i18n('0a60ac8f02ccd2cf723f927284877851') : row.isSubmit === "N" ? h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') : "" }}</div>
                        <el-select v-else v-model="row.isSubmit">
                          <el-option value="Y" :label="h_i18n('0a60ac8f02ccd2cf723f927284877851')"></el-option>
                          <el-option value="N" :label="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('9628c97d0a76ac2f7ddc699f7c838054')" width="80">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.selfPromise === "Y" ? h_i18n('0a60ac8f02ccd2cf723f927284877851') : row.selfPromise === "N" ? h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') : "" }}</div>
                        <el-select v-else v-model="row.selfPromise">
                          <el-option value="Y" :label="h_i18n('0a60ac8f02ccd2cf723f927284877851')"></el-option>
                          <el-option value="N" :label="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')" min-width="200">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.partName }}</div>
                        <h-file-upload delete download v-model="row.file" :only-show="tableList.phase3['submitStatus']==='Y'" @error="error" @download="download" @change="fileUploadToServer"></h-file-upload>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('e080329c020dc42739b9c0a043845712')" width="100">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.submitMan }}</div>
                        <el-input v-else v-model="row.submitMan"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('fb4cc0f776e82afd9c2b6ca157ddc639')" width="170">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ time(row.submitTime) }}</div>
                        <el-date-picker v-else v-model="row.submitTime" @change="changeTime(row.submitTime,row,'submitTime')" type="date"></el-date-picker>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('f2f6965f535dc9b2e0c14ad1fe521d5c')" width="100" v-if="tableList.phase3['checkStatus']==='R'">
                      <template #default="{row}">
                        {{ row.checkConclusion === "P" ? h_i18n('23c1f39900b3af4c3263449782e288e1') : row.checkConclusion === "F" ? h_i18n('9a7b15dccc5cda2e3db1110678576104') : h_i18n('2839c8c87d814d9a1e592965fae86b54') }}
                      </template>
                    </el-table-column>
                    <!-- <el-table-column label="海尔校核人" width="90" v-if="tableList.phase3['checkStatus']==='R'">
                      <template #default="{row}">
                        {{ row.checkManId }}
                      </template>
                    </el-table-column> -->
                    <el-table-column :label="h_i18n('6dfa721bf8e1c030997a72faeb4f5310')" width="100" v-if="tableList.phase3['checkStatus']==='R'">
                      <template #default="{row}">
                        {{ row.checkDepartment }}
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('8fce8f8923ab0343df4f1a0eb374a839')" width="100" v-if="tableList.phase3['checkStatus']==='R'">
                      <template #default="{row}">
                        {{ time(row.checkTime, 6) }}
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('6a64cef2c9cb2c04294df46180ac44b5')" width="100">
                      <template #default="{row}">
                        <div class="h-global-font--blue" @click="lookHistory(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</div>
                      </template>
                    </el-table-column>
                  </el-table>
                </h-table-card>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="h_i18n('412b229f1c250942327245f08107154b')" name="4">
            <div class="tab-item">
              <div class="table-item-button">
                <h-button-group>
                  <h-button type="primary" solid disabled v-if="tableList.phase4.commitStatus==='R'">
                    <template #icon>
                      <back-one/>
                    </template>{{ h_i18n('72649d75afec4f4ddbc7987cf765bcec') }}</h-button>
                  <h-button type="primary" solid disabled v-if="tableList.phase4.commitStatus==='Y'">
                    <template #icon>
                      <check/>
                    </template>{{ h_i18n('ecfa64c174d344d58f31a839c26bd7f9') }}</h-button>
                  <h-button type="primary" solid disabled v-if="tableList.phase4.submitStatus==='N'">{{ h_i18n('d185247bb225dc9262c4ed96ea4f9e26') }}</h-button>
                  <h-button type="primary" solid disabled v-else-if="tableList.phase3.commitStatus==='N'">{{ h_i18n('bd984b2f1c602bdfe4e0ac85fbc08c84') }}</h-button>
                  <template v-else>
                    <h-button type="primary" solid @click="publish(4,'no-pass')" v-if="tableList.phase4.commitStatus==='N'">
                      <template #icon>
                        <back-one/>
                      </template>{{ h_i18n('9a7b15dccc5cda2e3db1110678576104') }}</h-button>
                    <h-button type="primary" solid @click="publish(4,'pass')" v-if="tableList.phase4.commitStatus==='N'">
                      <template #icon>
                        <check/>
                      </template>{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</h-button>
                  </template>
                </h-button-group>
                <div class="text">{{ h_i18n('c86bb3a1ee637dcd53ff09712096fdad') }}</div>
              </div>
              <div class="table-item-table">
                <h-table-card :title="h_i18n('19fde6e4eac33cf5a9befed79c2309c8')">
                  <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" border :data="tableList.phase4.list" size="small"
                            @row-click="rowClick" :highlight-current-row="true" v-loading="tableListLoading"
                            ref="hazardousSubstances" :class="tableList.phase4['submitStatus']==='N'?'row-change':''">
                    <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')"></el-table-column>
                    <el-table-column label="*" width="60">
                      <template #header>
                        <div class="dangerColor center">*</div>
                      </template>
                      <template #default="{row}">
                        <div class="dangerColor center" v-if="row.isNeed==='Y'">*</div>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')" min-width="200">
                      <template #default="{row}">
                        <div class="text_item">{{ row.documentName }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('5b7fe94eb8c9dd382866a54435a9680e')" width="80">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.isSubmit === "Y" ? h_i18n('0a60ac8f02ccd2cf723f927284877851') : row.isSubmit === "N" ? h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') : "" }}</div>
                        <el-select v-else v-model="row.isSubmit">
                          <el-option value="Y" :label="h_i18n('0a60ac8f02ccd2cf723f927284877851')"></el-option>
                          <el-option value="N" :label="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('9628c97d0a76ac2f7ddc699f7c838054')" width="80">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.selfPromise === "Y" ? h_i18n('0a60ac8f02ccd2cf723f927284877851') : row.selfPromise === "N" ? h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') : "" }}</div>
                        <el-select v-else v-model="row.selfPromise">
                          <el-option value="Y" :label="h_i18n('0a60ac8f02ccd2cf723f927284877851')"></el-option>
                          <el-option value="N" :label="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')" min-width="200">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.partName }}</div>
                        <h-file-upload delete download v-model="row.file" :only-show="tableList.phase4['submitStatus']==='Y'" @error="error" @download="download" @change="fileUploadToServer"></h-file-upload>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('e080329c020dc42739b9c0a043845712')" width="100">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.submitMan }}</div>
                        <el-input v-else v-model="row.submitMan"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('fb4cc0f776e82afd9c2b6ca157ddc639')" width="170">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ time(row.submitTime) }}</div>
                        <el-date-picker v-else v-model="row.submitTime" @change="changeTime(row.submitTime,row,'submitTime')" type="date"></el-date-picker>
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('f2f6965f535dc9b2e0c14ad1fe521d5c')" width="100" v-if="tableList.phase4['checkStatus']==='R'">
                      <template #default="{row}">
                        {{ row.checkConclusion === "P" ? h_i18n('23c1f39900b3af4c3263449782e288e1') : row.checkConclusion === "F" ? h_i18n('9a7b15dccc5cda2e3db1110678576104') : h_i18n('2839c8c87d814d9a1e592965fae86b54') }}
                      </template>
                    </el-table-column>
                    <!-- <el-table-column label="海尔校核人" width="90" v-if="tableList.phase4['checkStatus']==='R'">
                      <template #default="{row}">
                        {{ row.checkManId }}
                      </template>
                    </el-table-column> -->
                    <el-table-column :label="h_i18n('6dfa721bf8e1c030997a72faeb4f5310')" width="100" v-if="tableList.phase4['checkStatus']==='R'">
                      <template #default="{row}">
                        {{ row.checkDepartment }}
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('8fce8f8923ab0343df4f1a0eb374a839')" width="100" v-if="tableList.phase4['checkStatus']==='R'">
                      <template #default="{row}">
                        {{ time(row.checkTime, 6) }}
                      </template>
                    </el-table-column>
                    <el-table-column :label="h_i18n('6a64cef2c9cb2c04294df46180ac44b5')" width="100">
                      <template #default="{row}">
                        <div class="h-global-font--blue" @click="lookHistory(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</div>
                      </template>
                    </el-table-column>
                  </el-table>
                </h-table-card>
              </div>
            </div>
          </el-tab-pane>

        </el-tabs>
      </div>
      <div class="table-footer">
        <h-button-group align="center">
          <h-button type="primary" @click="goBack">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </div>
    </div>
    <!--导入模版-->
    <h-upload-template :loading="loadingDown" @error="error" :title="h_i18n('db547c476bed52ec7c8ea817e929b790')" :show="upload" @close="closeUpload" :status="status" :dataList="dataList" @download="download" @fileChange="uploadTemplate"></h-upload-template>
    <!--历史-->
    <el-drawer v-model="flow" direction="rtl" :show-close="false" :size="560">
      <template #title>
        <div class="titleDrawer">{{ h_i18n('6a64cef2c9cb2c04294df46180ac44b5') }}</div>
        <h-button style="margin-left: 10px" type="warning" @click="flow=false">
          <template #icon>
            <close theme="outline"/>
          </template>{{ h_i18n('b15d91274e9fc68608c609999e0413fa') }}</h-button>
      </template>
      <div>
        <el-table :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" border :data="historyList" size="small" height="100vh" style="height: calc(100vh - 51px)">
          <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')"></el-table-column>
          <!-- <el-table-column label="校核人" prop="auditName" min-width="80"></el-table-column> -->
          <el-table-column :label="h_i18n('bd08bc882566e593d5b65e04ef64dbb7')" prop="checkDepartment" min-width="100"></el-table-column>
          <el-table-column :label="h_i18n('5a98b64b0d0c8c704b66d494ea784ab4')" prop="auditDate" min-width="170" :formatter="timeFormatter"></el-table-column>
          <el-table-column :label="h_i18n('91bb7059c3b8b9267b0238a6149fa167')" min-width="90">
            <template #default="{row}">
              {{ row.auditConclusion === "P" ? h_i18n('23c1f39900b3af4c3263449782e288e1') : row.auditConclusion === "F" ? h_i18n('9a7b15dccc5cda2e3db1110678576104') : h_i18n('2839c8c87d814d9a1e592965fae86b54') }}
            </template>
          </el-table-column>
          <el-table-column :label="h_i18n('2432b57515b3627faddccb1dd1df206e')" prop="auditText" min-width="200"></el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </h-form-page>


</template>




<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import {Time, Request, Loading} from "../../../Decorator/vue2-decorator";

export default {
  name: "UploadSelfInspectionData",
  data() {
    return {
      activeName: "1",
      beforeData: {},
      tableData: {},
      mainData: {},
      tableList: {
        phase1: {},
        phase2: {},
        phase3: {},
        phase4: {}
      },
      tableListLoading: false,
      multipleSelection: [],
      fileUpload: false,
      nowItem: {},
      fileList: [],
      cataId: 0,
      loadingDown: false,
      upload: false,
      dataList: [],
      status: "",
      commitment: false,
      declarationFormList: [],
      name: "",

      ratify: false,
      approveList: [],
      commitmentRatify: false,
      formType: "",

      flow: false,
      historyList: []
    }
  },
  mounted() {
    this.name = this.$route.query.name
    this.init()
  },
  methods: {
    h_i18n,
    lookT(){
      window.open("http://l.ihaier.com/")
    },

    @Request("vmiService")
        @Loading(h_i18n('8cc060fe901a77ab411cfb727b7737f2'))
    lookHistory(row) {
      return request({
        method: 'get',
        url: '/patternPlan/checkPpapDetailHistory?patternPlanId=' + this.beforeData.patternPlanId + "&fileId=" + row.documentId,
      }).then(res => {
        if (res.data.code === "200") {
          this.flow = true
          this.historyList = res.data.data.map(v => ({...v, checkDepartment: row.checkDepartment}))
        } else {
          this.error(h_i18n('8318ed1b717596337d72e5ba947ac668') + res.data.data)
        }
      }).catch((() => {
        this.error(h_i18n('8318ed1b717596337d72e5ba947ac668'))
      }))
    },

    @Loading(h_i18n('0050e7fcccb5506f3e2e9ba240196f0e'))
    fileUploadToServer(file) {
      let formData = new FormData()
      formData.append('files', file.file)
      return this.$http({
        method: 'post',
        url: '/base/fileUpload/uploadToOss',
        headers: {'Content-Type': 'multipart/form-data'},
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
      }).then(res => {
        if (res.data.code === "0") {
          file.url = res.data.data
        } else {
          file.name = null
        }
      }).catch(v => {
        file.name = null
      })
    },

    error(value) {
      this.warning(value)
    },

    @Loading(h_i18n('8ffe8dae6d15a5be77490834bff8d28b'))
    download(file) {
      return this.$http({
        method: 'get',
        url: '/base/fileDownload/downloadFile?filePath=' + file.url,
        responseType: "blob",
      }).then(async res => {
        if (res.status === 200) {
          let blob = new Blob([res.data]); // 文件流
          let blobUrl = URL.createObjectURL(blob);
          const link = document.createElement("a"); //模拟a链接，不支持低版本ie
          link.download = file.name;
          link.style.display = "none";
          link.href = blobUrl;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        } else {
          this.error(h_i18n('15efc64c8e8760bc029f83ee59efa351'))
        }
      })
    },

    @Time(1, "yyyy-MM-dd")
    changeTime(time, last, row, con) {
      row[con] = time
    },
    @Time(3, "yyyy-MM-dd HH:mm:ss")
    timeFormatter(a) {
      return a
    },

    goDetail(row) {
      if (row.rohsNo && row.rohsNo != '无') {
        let url = process.env.NODE_ENV === "test" ? "http://sqm-test.qd-huangdao-test.haier.net/" : process.env.NODE_ENV === "production" ? "http://sqm.haier.net/" : ""
        window.open(url + "newproduct/rohs_detail_haier_index?id=" + row.rohsNo, "_black");
      } else {
        this.info(h_i18n('7435bdcd1a5956a38b04f15fef15d086'));
      }
    },
    lookPlan() {
      this.$router.push('/SampleInspectionFormLook?patternPlanId=' + this.tableData.patternPlanId + "&dataFrom=sqm")
    },
    lookM(a, b) {
      this.$router.push({
        name: "EnterpriseStandardList",
        query: {
          mtlNo: a,
          supplyCode: b
        }
      })
    },
    //****************************************************自检上传****************************************************
    //进入查询
    async init() {
      this.beforeData = JSON.parse(this.$route.query.data)
      await this.searchTableList()
    },

    @Time(1, "yyyy-MM-dd")
    time(a) {
      return a
    },
    //关闭导入模版
    closeUpload() {
      this.upload = false
      this.dataList = []
      this.status = ""
    },
    //二三级物料，自制外协切换
    specificationChange(row) {
      row.partStatus = row.partStatusList.join(",").replace(h_i18n('f5f45a306153e09e6b55aa8989e62e29'), "1").replace(h_i18n('762f7d6568ff7dcbccb00c818e08c451'), "2")
    },

    //二三级物料，列表选中
    listCheckBoxChange(val) {
      this.multipleSelection = val.map(v => v.checkFrontId);
    },

    //更新页面高度
    inspectionUpdate(height) {
      this.postThisPageHeight()
    },
    //点击四个列表TAB页
    handleClick(a) {
      console.log(a)
    },
    //查询样检单，四个列表和详情
    searchTableList() {
      this.startLoading(h_i18n('a1fa355af4de9de33a401ebb044bffb3'))
      this.tableListLoading = true
      return this.$http({
        method: "get",
        url: "/base/patternPlan/searchPpapPlanDetails?patternPlanId=" + this.beforeData.patternPlanId,
      }).then(res => {
        if (res.data.code === "200") {
          // console.log(res)
          this.mainData = res.data.data.ppapPlanNew
          //四个阶段
          for (let i = 1; i <= 4; i++) {
            this.tableList["phase" + i] = {
              ...res.data.data.stageList.filter(v => v.stage === i)[0],
              plan: i === 2,
              list: res.data.data.documents.filter(v => v.stage === i).map(v => ({...v, file: {name: v.fileName, url: v.filePath}})),
            }
            if (i === 2) {
              this.tableList["phase" + i]["materials"] = res.data.data.materials.map(res => {
                return {
                  ...res,
                  partStatusList: res.partStatus.replaceAll("1", h_i18n('f5f45a306153e09e6b55aa8989e62e29')).replaceAll("2", h_i18n('762f7d6568ff7dcbccb00c818e08c451')).split(","),
                  checkFront: false,
                  checkFrontId: this.md5(this.uuid2()),
                  checkFrontType: "materials"
                }
              })
            }
          }

          this.tableListLoading = false
        } else {
          this.tableListLoading = false
        }
        this.closeLoading()
      }).catch(e => {
        this.closeLoading()
        this.tableListLoading = false
      })
    },
    //四个列表，每一行点击成输入框
    rowClick(row) {
      if (row.checkFrontType === "materials") {
        if (this.tableList["phase2"]["submitStatus"] === "N") {
          this.tableList["phase2"]["materials"].forEach(v => v.checkFront = false)
          row.checkFront = true
        }
      } else {
        if (this.tableList["phase" + row.stage]["submitStatus"] === "N") {
          this.tableList["phase" + row.stage]["list"].forEach(v => v.checkFront = false)
          row.checkFront = true
        }
      }
    },
    //样检单列表每一行格式化，添加一个key
    addCheckId(list, type) {
      return list.map(v => {
        return {
          ...v,
          checkFrontId: this.md5(this.uuid2()),
          checkFront: false,
          checkFrontType: type
        }
      })
    },

    //四个保存，分别
    //标准评审(一阶段)发布
    //过程控制(二阶段)发布
    //检验测试(三阶段)发布
    //PPAP批准(四阶段)发布
    publish(type, publish) {
      this.startLoading(`${h_i18n('ac007746080a48f195815c62f8c1570c')}${type}${h_i18n('419f6a8037e450ae67f8716acf6171ff')}`)
      let list = this.tableList["phase" + type].list
      return this.$http({
        method: "POST",
        url: "/base/patternPlan/auditPpapDetail?userName=" + this.name + "&stage=" + type + "&type=" + publish,
        data: list
      }).then(res => {
        if (res.data.code === "200" || res.data === true) {
          this.success(`${h_i18n('ac007746080a48f195815c62f8c1570c')}${type}${h_i18n('0851d90e3305a8a8e5aacb84daa3702c')}`)
          this.searchTableList()
        } else {
          this.error({
            title: h_i18n('250688d7c9bd56b8ab11592fa83d670b'),
            message: res.data.msg,
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721')
          })
        }
        this.closeLoading()
      })
    },
    //返回上一个页面
    goBack() {
      this.$router.back()
    },
  }
}
</script>

<style scoped lang="scss">
.page {
  //.cell {
  //  div {
  //    text-align: left;
  //  }
  //}
  .item-look {
    display: inline-block;
  }

  .table-top {
    padding: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 10px;
    box-sizing: border-box;

    .title-table {
      display: flex;
      height: 30px;
      font-size: 16px;
      justify-content: space-between;
      font-weight: 600;

      .right {
        font-weight: 500;
      }
    }

    .item {
      margin-top: 10px;

      .item_table {
        width: 100%;

        tr {
          th {
            height: 40px;
            font-size: 16px;
            font-weight: 400;
          }

          td {
            height: 40px;
            font-size: 14px;
            font-weight: 400;
            text-align: center;
          }
        }
      }
    }
  }

  .table-tab {
    margin-top: 10px;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;

    .footer_check {
      display: flex;
      padding: 0 5px;
      font-size: 16px;
      color: #165DFF;
      font-weight: 900;
      justify-content: center;
      align-items: center;

      :deep(.el-checkbox) {
        display: flex;
        align-items: center;
      }

      :deep(.el-checkbox__input) {
        display: inline-flex;
        align-items: center;
      }

      :deep(.el-checkbox__label) {
        font-size: 16px;
      }
    }

    .demo-tabs {
      :deep(.el-tabs__content) {
        padding: 10px;
        min-height: 320px;
      }

      .tab-item {
        width: 100%;
        height: 100%;

        .table-item-button {
          display: flex;

          .text {
            color: #D9001B;
            font-size: 16px;
            display: flex;
            margin-left: 20px;
            align-items: center;
          }
        }

        .table-item-list {
          display: flex;
          height: 32px;
          margin-top: 10px;
          border: 1px solid #E5E6EB;
          border-radius: 8px;
          overflow: hidden;

          .item-one {
            width: 200px;
            flex: none;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            border-left: 1px solid #E5E6EB;
            padding: 0 10px;
          }


          .item-bg {
            background-color: #DDEDFE;
          }

          .item-one:first-child {
            border-left: 0;
          }

          .item-two {
            width: 0;
            border-left: 1px solid #E5E6EB;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            flex: 1;
            line-height: 32px;
            padding: 0 10px;
            font-size: 14px;
          }
        }
      }
    }

    .text_item {
      white-space: nowrap;
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .text_item:hover {
      white-space: normal;
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .text_item_delete {
      user-select: none;
      display: inline-block;
    }
  }

  .table-footer {
    padding: 10px;
    background-color: #fff;
    margin-top: 10px;
    border-radius: 10px;
  }

  .row-change {
    .current-row {
      td {
        padding: 7.5px 0;
      }
    }
  }
}

.footer_check_ratify {
  display: flex;
  padding: 0 5px;
  font-size: 16px;
  color: #165DFF;
  font-weight: 900;
  height: 50px;
  justify-content: center;
  align-items: center;
}

:deep(.el-drawer__header) {
  margin-bottom: 10px;
  padding: 0 10px;
  font-weight: 900;
  border-bottom: 1px dashed #ccc;
}

.titleDrawer {
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
}

</style>